import { Component } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';

import { FormInputViewerService } from '../../form-input-viewer.service';

@Component({
	selector   : 'checkbox-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
	animations : fuseAnimations
})
export class CheckboxInputComponent{

	constructor(
		public inputService: FormInputViewerService
	){}
}
